module.exports = __webpack_public_path__ + "static/017-743125039a9f0260b3059b23b202d702.png";